import styled from 'styled-components';

import { FlexGap, tokens } from '@treams/treams-ui';

const NotePanel = styled(FlexGap).attrs({
	gap: tokens.gap.list,
	flexDirection: 'column',
	p: 3,
})`
	background: ${tokens.surface.secondary};
	border: 1px solid ${tokens.border.subtle};
	border-radius: ${tokens.radius.sm}px;
`;

export default NotePanel;
